import { render, staticRenderFns } from "./UserStatsTable.vue?vue&type=template&id=36e2284f&scoped=true&"
import script from "./UserStatsTable.vue?vue&type=script&lang=ts&"
export * from "./UserStatsTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserStatsTable.vue?vue&type=style&index=0&id=36e2284f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2284f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VSpacer,VTextField})
